import { fetchCardBin } from "./fetch-subscription";

export const getBrand = async (number: string) => {
  const brand = await fetchCardBin(number);
  return brand;
};
